import axios from "axios";
import Swal from "sweetalert2";
import { brand } from "../../../../config/brands";

const api = axios.create({
  baseURL: process.env.REACT_APP_ORTHOCHECK_URL,
  timeout: 10000,
});

const apiHandler = async ({
  method,
  url,
  headers = {},
  params = {},
  data = {},
  raw = false,
  swalError = false,
}) => {
  try {
    const response = await api({
      method,
      url,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...headers,
      },
      params,
      data,
    });

    console.log("API request successful. Response:", response.data);
    return raw ? response : response.data;
  } catch (error) {
    const status = error.response?.status;
    const apiMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Something went wrong. Please try again.";

    if (
      (status === 401 || status === 403) &&
      error.response?.config?.baseURL === process.env.REACT_APP_ORTHOCHECK_URL
    ) {
      await Swal.fire({
        icon: "warning",
        title: "Your session has expired",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      window.location.href = `${brand.webUrl}`;
      return;
    }

    if (swalError) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: apiMessage,
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      window.location.href = `${process.env.REACT_APP_PARENT_ORIGIN}/orthocheck`;
      return;
    }

    console.error(
      "API request failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export default apiHandler;
